import { render, staticRenderFns } from "./setUserConfigurationInstagram.vue?vue&type=template&id=29542418&scoped=true&"
import script from "./setUserConfigurationInstagram.vue?vue&type=script&lang=js&"
export * from "./setUserConfigurationInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29542418",
  null
  
)

export default component.exports